var module = angular.module('octopusApp.configuration');

module.directive("eventFilter", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      projects: '=',
      environments: '=',
      roles: '=',
      users: '=',
      tenants: '=',
      tagSets: '=',
      eventGroups: '=',
      eventCategories: '=',
      selectedFilters: '='
    },
    templateUrl: 'areas/configuration/audit/views/event_filter.html',
    controller: function($scope) {
      var vm = this;

      var getTags = function(selectedOptions, allOptions) {
        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
          return "";
        }
        var selectedOptionsArray = selectedOptions.split(",");
        var result = [];
        _.each(allOptions, function (e) {
          if (_.contains(selectedOptionsArray, e.Id)) {
            result.push(e.Name);
          }
        });
        return result.join(",");
      };

      var refreshEventGroupCategories = function () {
        if (!vm.selectedFilters)
        {
          return;
        }

        if (vm.selectedFilters.eventGroups.length > 0) {
          var selectedGroups = _.filter(vm.eventGroups, function (eventGroup) {
            return vm.selectedFilters.eventGroups.indexOf(eventGroup.Id) > -1;
          });
          var selectedEventCategoryIds = _.flatten(_.map(selectedGroups, function (selectedGroup) {
            return selectedGroup.EventCategories;
          })).join(",");
          vm.selectedFilters.selectedEventGroupCategories = getTags(selectedEventCategoryIds, vm.eventCategories);
        } else {
          vm.selectedFilters.selectedEventGroupCategories = [];
        }
      };

      $scope.$watch(function () { return vm.selectedFilters ? vm.selectedFilters.eventGroups : vm.selectedFilters; }, function() {
        refreshEventGroupCategories();
      });
    },
    controllerAs: 'vm',
    bindToController: true
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/directives/event_filter.js
// module id = 379
// module chunks = 1